export default "__VITE_ASSET__qV9dAqmd__"